/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { X, History } from "lucide-react";

const HistoryModal = ({
  showHistoryModal,
  history,
  historyLoading,
  getStatusColor,
  onClose,
}) => {
  if (!showHistoryModal) return null;

  const formatHistoryItem = (h) => ({
    status: h.status,
    changedBy: h.changedBy?.name || "Unknown",
    changedAt: new Date(h.changedAt).toLocaleString(),
    reminder: h.reminder || "",
  });

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-card dark:bg-dark-surface rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="px-6 py-5 border-b border-gray-100 dark:border-dark-border flex justify-between items-center">
          <h2 className="text-lg font-bold text-text dark:text-dark-text flex items-center gap-2">
            <History size={20} /> Status History
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-dark-text"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-0 overflow-y-auto max-h-[60vh]">
          {historyLoading ? (
            <div className="flex justify-center items-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              <span className="ml-3 text-gray-500 dark:text-dark-muted">
                Loading history...
              </span>
            </div>
          ) : history.length > 0 ? (
            <table className="w-full text-sm">
              <thead className="bg-gray-50 dark:bg-gray-800 text-gray-500 dark:text-dark-muted uppercase text-xs font-semibold">
                <tr>
                  <th className="px-6 py-3 text-left">Status</th>
                  <th className="px-6 py-3 text-left">Changed By</th>
                  <th className="px-6 py-3 text-left">Date & Time</th>
                  <th className="px-6 py-3 text-left">Reminder</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                {history.map((h, i) => {
                  const formattedItem = formatHistoryItem(h);
                  return (
                    <tr key={i} className="bg-white dark:bg-gray-900">
                      <td className="px-6 py-4">
                        <span
                          className={`inline-flex px-2 py-0.5 rounded text-xs font-bold border ${getStatusColor(
                            formattedItem.status,
                          )}`}
                        >
                          {formattedItem.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-gray-600 dark:text-dark-muted">
                        {formattedItem.changedBy}
                      </td>
                      <td className="px-6 py-4 text-gray-500 dark:text-dark-muted">
                        {formattedItem.changedAt}
                      </td>
                      <td className="px-6 py-4 text-gray-500 dark:text-dark-muted">
                        {formattedItem.reminder || "—"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className="py-12 text-center text-gray-500 dark:text-dark-muted">
              <History size={48} className="mx-auto mb-4 opacity-30" />
              <p className="text-lg font-medium">No history found</p>
              <p className="text-sm mt-1">
                No status changes recorded for this booking.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HistoryModal;
